var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 385L512 413",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 512.5,
    cy: 380.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M507.987 380.19C507.987 376.283 511.288 373.117 515.358 373.117C515.943 373.117 516.511 373.184 517.056 373.308C515.742 372.48 514.187 372 512.519 372C507.814 372 504 375.806 504 380.5C504 385.194 507.814 389 512.519 389C514.814 389 516.895 388.093 518.427 386.62C517.492 387.032 516.454 387.263 515.358 387.263C511.288 387.263 507.987 384.096 507.987 380.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521.402 379.6L521.37 377.146L519.535 378.719L517.304 378.056L518.112 380.337L516.765 382.381L519.1 382.218L520.499 384.144L521.133 381.763L523.345 380.909L521.402 379.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.4e413dc005eaf6cd583ba52f27528512.svg";
export { ForwardRef as ReactComponent };